.app {
	bottom: 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	flex: 1 0 auto;
	left: 0;
	min-width: var(--jpo-common-min-app-width);
	position: absolute;
	right: 0;
	top: 0;
}
